import * as betroyale from './Basic.styles.betroyale';
import * as fiestabet from './Basic.styles.fiestabet';
import * as goldenrush from './Basic.styles.goldenrush';
import * as juicybet from './Basic.styles.juicybet';
import * as puntcity from './Basic.styles.puntcity';
import * as puntgenie from './Basic.styles.puntgenie';
import * as questbet from './Basic.styles.questbet';
import * as vikingbet from './Basic.styles.vikingbet';
import * as volcanobet from './Basic.styles.volcanobet';
import * as wellbet from './Basic.styles.wellbet';
import * as forsport from './Basic.styles.forsport';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
};
